import warning from '@acorn-portal/shared/src/assets/images/warning-sign.png';
import { Box, Grid, Paper, styled, Typography } from '@mui/material';
const Image = styled('img')({});

const defaultText =
	'Please make sure you have the additional drivers consent & driving licence number with you, as we may need this information to provide you with a quote.';

const DLNumberDisclaimer = ({ text = defaultText }: { text?: string }) => (
	<Paper
		elevation={0}
		sx={(theme) => ({
			display: 'flex',
			flexDirection: 'row',
			p: 2,
			my: 2,
			alignItems: 'center',
			'& img': {
				marginRight: 2,
			},
			[theme.breakpoints.down('sm')]: {
				width: '100%',
				alignItems: 'center',
				textAlign: 'center',
				'& img': {
					width: '20%',
					marginRight: 2,
				},
			},
		})}
	>
		<Grid container direction='row' sx={{ m: 1, alignItems: 'center' }}>
			<Grid size={{ xs: 12, sm: 1 }}>
				<Image src={warning} alt='warning' />
			</Grid>
			<Grid size={{ xs: 12, sm: 11 }}>
				<Box sx={(theme) => ({ [theme.breakpoints.down('md')]: { mx: 2 } })}>
					<Typography variant='body2' sx={{ mt: 1 }}>
						{text}
					</Typography>
				</Box>
			</Grid>
		</Grid>
	</Paper>
);

export default DLNumberDisclaimer;
